<template>
  <v-text-field
    :value="value"
    :append-icon="appendIcon"
    :name="name"
    :label="label"
    :type="type"
    @input="(value) => $emit('input', value)"
    :error-messages="errorMessages"
    :required="required"
    :outlined="outlined"
    :dense="dense"
    :maxlength="maxLength"
  ></v-text-field>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
    required: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    name: { type: String, default: '' },
    appendIcon: { type: String, default: '' },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    maxLength: { type: Number, default: undefined },
    errorMessages: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style></style>
